<template>
  <!--v-if="(publishStatus == 1 && classStatus == 0) || (publishStatus == 1 && classStatus == 1)"-->
  <div v-if="(publishStatus == 1 && classStatus == 0) || (publishStatus == 1 && classStatus == 1)" class="qrCode">
    <div class="qrCode_button">
      <button class="btn btn-default" v-print="printParam">打印</button>
    </div>
    <div class="qrCode_div" id="outerDiv">
      <img class="qrCode_div_pic" :src="qrCodeObj.codeUrl" />
      <div class="qrCode_div_className">{{clazzName}}</div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
  import {schoolAxios} from "../../main";
  import {getContentSize} from '../mainView';
  import dictionaryData from '../../json/dictionary';

  export default {
    name: "qrCodeTea",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        qrCodeObj:{
          codeUrl:''
        },
        clazzName: '',
        printParam: {
          id: 'outerDiv',
          popTitle: '打印',
          extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
        }
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.qrCodeProduct();
        this_.initClassDetails();
      });
    },
    methods: {
      //生成班级二维码
      qrCodeProduct(){
        let this_=this;

        schoolAxios({
          method: 'post',
          url: 'clazz/generateClassQrCode',
          data: {
            "clazzId":this_.clazzId
          },
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.qrCodeObj.codeUrl = this_.$store.state.serviceBase + "resources/" + data.data;
          }
        });
      },

      /**
       * 查询班级名称
       */
      initClassDetails(){
        let this_=this;
        if(this_.clazzId) {
          schoolAxios({
            method: 'get',
            url: 'clazz/load/' + this_.clazzId,
            params: {}
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              this_.clazzName = data.data.name;
            }
          });
        }
      },

    }
  }
</script>

<style scoped>
  @import '../../assets/css/plugins.css';
  @import "../../assets/css/publicStyle.css";
  @import "../../assets/css/qrCode.css";
</style>



// WEBPACK FOOTER //
// src/components/teacherClass/qrCodeTea.vue